module.exports = __webpack_public_path__ + "img/icon-ellipsis-v.6e5f7bcb.svg";